"use client"

import { useAppSelector } from "@/hooks/redux"
import { Skeleton } from "antd"

const ProductColorButtonSkeleton = () => {
  const colorsSelectionSetting = useAppSelector(state => state.store.store_setting.data.colors_selection)

  return (
    <Skeleton.Button
      size="large"
      shape='circle'
      style={{
        height: `calc(${colorsSelectionSetting.height / 10}rem + ${colorsSelectionSetting.border_width}px)`,
        width: `calc(${colorsSelectionSetting.width / 10}rem + ${colorsSelectionSetting.border_width}px)`,
      }}
    />
  )
}

export default ProductColorButtonSkeleton